import { updateMyself } from 'actions/myself';
import { ApiResultMessageQualityEffect } from 'types/app/messages';
import { IQuality } from 'types/qualities';

export default function processStandardMessages(standardMessages: ApiResultMessageQualityEffect[]) {
  return (dispatch: Function) => {
    const qualityEffects: { possession: IQuality }[] = standardMessages
      .filter(m => m.possession)
      .map(m => ({ possession: m.possession! }));

    dispatch(updateMyself(qualityEffects));
  };
}